/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Social_Sciences14Inputs */

const en_cv_extract_form_enum_social_sciences14 = /** @type {(inputs: Cv_Extract_Form_Enum_Social_Sciences14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Social Sciences`)
};

const de_cv_extract_form_enum_social_sciences14 = /** @type {(inputs: Cv_Extract_Form_Enum_Social_Sciences14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sozialwissenschaften`)
};

/**
* | output |
* | --- |
* | "Social Sciences" |
*
* @param {Cv_Extract_Form_Enum_Social_Sciences14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_social_sciences14 = /** @type {((inputs?: Cv_Extract_Form_Enum_Social_Sciences14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Social_Sciences14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_social_sciences14(inputs)
	return en_cv_extract_form_enum_social_sciences14(inputs)
});
export { cv_extract_form_enum_social_sciences14 as "cv_extract_form_enum_SOCIAL_SCIENCES" }